import { useState, useContext, useEffect} from 'react';
import './style.scss';

import { ReactComponent as CheckMark } from '../../st-check.svg';
import { FormDataContext } from '../FormDataProvider';

import MemberFeeStep from '../MemberFeeStep';
import MembershipStep from '../MembershipStep';
import ConfirmStep from '../ConfirmStep';
import loadingScreen from '../LoadingScreen';
import LoadingScreen from '../LoadingScreen';

function Form() {

   const { currentStep, currentStepValid, changeStep, stepList, submitLoading, formErrors, submitForm } = useContext(FormDataContext);
   const [hasClickedNext, changeHasClickedNext] = useState(false);

   const onClickNext = () => {

        if (hasClickedNext) {

            if (!currentStepValid) {
                document.getElementById('form-validation-errors').innerHTML = "Vänligen fyll i alla obligatoriska fält *";
                return;
            }

            document.getElementById('form-validation-errors').innerHTML = "";
        }

        // We are on the last step. Send form data to backend
        if (stepList[currentStep] == ConfirmStep) {
            submitForm();
            return;
        }

        changeStep(true);
        changeHasClickedNext(true);
    }

  return (
    <div className="form">
        <div className="form-wrapper">

            {!submitLoading ? <>

                <div className="form__header">
                    {stepList.map((step, index) => {
                        return (
                            <div key={index} className="form__header__step">
                                <div className={`form__header__step__number ${index <= currentStep ? 'done' : ''} ${index === currentStep ? 'active' : ''}`}>
                                    <span>{index < currentStep ? <CheckMark/> : index + 1}</span>
                                </div>
                            </div>
                        )
                    })}
                </div>
                

                <div className="form__steps">
                    {stepList[currentStep] && stepList[currentStep]()}
                </div>

                <div id="form-validation-errors"></div>

                {Object.entries(formErrors).length > 0 && <div className="form__errors">
                    <p>Vänligen kontrollera följande:</p>
                    <ul>
                        {Object.keys(formErrors).map((error, index) => {

                            // Remove -svt prefix from error key
                            var elementKey = error;
                            if (elementKey.indexOf('svt-') !== -1) {
                                elementKey = elementKey.replace('svt-', '');
                            }

                            // Try to find input with elementKey name
                            var element = document.querySelectorAll('[name="' + elementKey + '"]');
                            if (element.length > 0) {
                                element[0].parentElement.classList.add('invalid');
                            }

                            var theError = formErrors[error];

                            // if theError is an object, make it into an array
                            if (typeof theError === 'object') {
                                theError = Object.values(theError);
                            }

                            return (
                                <li key={index}>{theError}</li>
                            )
                        }
                        )}
                    </ul>
                </div>}

                <div className="form__buttons">
                    {currentStep >= 0 && stepList[currentStep] !== MembershipStep && stepList[currentStep] !== MemberFeeStep && <button onClick={() => onClickNext(true) } className={`form__buttons next ${!currentStepValid ? 'disabled' : ''}`}>{stepList[currentStep] !== ConfirmStep ? <>Fortsätt</> : <>Skicka in ansökan</>}</button>}
                    {currentStep > 0 && <button onClick={() => changeStep(false)} className="form__buttons back">Gå tillbaka</button>}
                </div>

            </> : <LoadingScreen />}
        </div>
    </div>
  );
}

export default Form;
